import {
  PROMOTION_DATA,
  USER_MANAGEMENT_ADMIN_LIST,
  USER_MANAGEMENT_LIST,
  SUPER_ADMIN_LIST,
  USER_MANAGEMENT_USER_LIST,
  OFFERS_LIST,
  OPERATOR_LIST,
  GET_EMPLOYEE_LIST,
  GET_PARTNER_LIST,
  ADS_LIST,
  GET_ADS,
  REQUEST_MANAGEMENT_DATA,
  GET_ROLE_NAME,
  GET_PERMISSIONS,
  GET_ROLES,
  REQ_PROMOTION_DATA,
  CLIENT_DATA,
  IMPORT_DATA_LIST,
  COMPANY_SETTING,
  EMPLOYEE_DOC,
  OPERATOR_DOC,
  PARTNER_DOC,
  GET_SUBSCRIPTION,
  FORGOT_PASSWORD,
  PRODUCT_OWNER_DATA,
  UNREAD_NOTIFICATION,
  NOTIFICATION_DATA,
  GET_ADS_CLIENT,
  GET_PERMISSION_COUNT,
  GET_ROLES_COUNT,
  GET_OPERATOR_NAME,
  USER_SETTINGS_EDIT,
  GET_OP_EMP_COUNT,
  GET_PRO_EMP_COUNT,
  GET_MOBILE_ADS,
  GET_OPERATOR_EMAILID,
  GET_ALL_EMAIL_INFO,
  GET_RECENT_OFFERS,
  GET_RECENT_ADS,
  GET_RECENT_PROMOFILE,
  REQ_MAN_OFFERS,
  GET_REQ_ADS,
  OPERATOR_BYID,
  PARTNER_BYID,
  BIN_DATA,
  TBS_INFO,
  REFER_EARN,
  REDEEM_OFFER,
  OPERATOR_DATA,
  PROMO_BG_IMAGE,
  GET_REQ_PARTNER,
  GET_ROLES_PERMISSION,
  GET_REQ_MOB_ADS,
  THEME_BACKGROUND,
  // GET_BG_IMAGE,
  // STARTER_IMAGE,
  GET_BOOKING_DETAILS,
  GET_DASHBOARD_DETAILS,
  GET_CANCELLATION_DETAILS,
  GET_PASSENGER_DETAILS,
  GET_BLOCKED_DETAILS,
  GET_ALL_MOBILE_NUMBERS,
  GET_AVAILABLE_BALANCE,
  GET_PAYMENT_DETAILS,
  GET_SETTLEMENT_DETAILS,
  GET_REFUND_DETAILS,
  GET_USAGE_DETAIL,
  GET_BARCHART_DETAILS,
  GET_MOBILE_NOTIFICATION,
  GET_ACCESSID,
  GET_TBS_DEAL,
  GET_ABHIBUS_HISTORY,
  GET_PAT_DASHBOARD_DETAILS,
  GET_PAT_INSTALL_DETAILS,
  GET_PAT_BOOKING_DETAILS,
  GET_SETTLEMENT_DETAILS_BY_MONTH,
  GET_REFUND_REQUEST,
  GET_USER,
  GET_NUMBER,
  RESETNUMBER,
  GET_COMMISSION,
  GET_RAZORPAY_DETAILS,
  GET_APP_VERSIONINFO,
  //Super Admin Vault
  CREDENTIALS_LIST,
  DOCUMENTS_LIST,
  ADMIN_ACTIVITY_LOG,
  CONTACTS_LIST,
} from "./Type";

const initialState = {
  promotion_data: [],
  user_management_admin_list: [],
  user_management_user_list: [],
  offers_list: [],
  super_admin_list: [],
  operator_list: [],
  employee_list: [],
  partner_list: [],
  ads_list: [],
  request_management: [],
  req_promotion: [],
  client_data: [],
  import_data: [],
  company_setting: [],
  employee_documents: [],
  operator_documents: [],
  partner_documents: [],
  subscription_list: [],
  forgot_password: [],
  product_owner_data: [],
  unread_notification: [],
  notification_data: [],
  ads_client_list: [],
  permission_count: [],
  roles_count: [],
  operator_name: [],
  user_settings_edit: [],
  op_emp_count: [],
  pro_emp_count: [],
  mobile_adsList: [],
  get_all_email_info: [],
  get_all_operator_email: [],
  notification_count: "",
  req_man_offers: [],
  get_req_ads: [],
  operator_byid: {},
  bin_data: [],
  tbs_info: {},
  refer_earn: [],
  operator_data: [],
  promo_bg: "",
  get_req_partner: [],
  get_roles_permission: [],
  get_req_mob_ads: [],
  theme_background: [],
  booking_details: [],
  dashboard_details: [],
  cancellation_details: [],
  passenger_details: [],
  blocked_details: [],
  all_mobile_numbers: [],
  available_balance: [],
  payment_details: [],
  settlement_details: [],
  refund_details: [],
  barchart_details: [],
  mobile_notification: "",
  access_id: "",
  tbs_deal: [],
  abhibus_history: [],
  pat_dashboard_details: [],
  pat_install_details: [],
  pat_booking_details: [],
  settlement_bymonth: [],
  refund_request: [],
  user_detail: [],
  user_number: "",
  commission: [],
  razorpay_details: [],
  app_versioninfo: [],

  // get_bg_image: [],
  // starter_image:"",
  documents_list: [],
  admin_activity_log: [],
  contacts_list: [],
  credentials_page_context: {},
  contacts_page_context: {},
  documents_page_context: {},
};

export const crmreducer = (state = initialState, action) => {
  // const { type, payload, payload_count } = action;
  const { type, payload, payload_count, pageContext } = action;
  switch (type) {
    case PROMOTION_DATA:
      console.log(payload, "PROMOTION_DATA");
      return {
        ...state,
        promotion_data: payload,
      };
    case USER_MANAGEMENT_ADMIN_LIST:
      return {
        ...state,
        user_management_admin_list: payload,
      };
    case USER_MANAGEMENT_USER_LIST:
      return {
        ...state,
        user_management_user_list: payload,
      };
    case OFFERS_LIST:
      console.log(payload, "OFFERS_LIST");
      return {
        ...state,
        offers_list: payload,
      };
    case SUPER_ADMIN_LIST:
      console.log(payload, "super_admin_list");
      return {
        ...state,
        super_admin_list: payload,
      };
    case OPERATOR_LIST:
      console.log(payload, "operator_list_payload");
      return {
        ...state,
        operator_list: payload,
      };
    case GET_EMPLOYEE_LIST:
      return {
        ...state,
        employee_list: payload,
      };
    case GET_PARTNER_LIST:
      return {
        ...state,
        partner_list: payload,
      };
    case ADS_LIST:
      return {
        ...state,
        ads_list: payload,
      };
    case GET_ADS:
      return {
        ...state,
        ad_list: payload,
      };
    case REQUEST_MANAGEMENT_DATA:
      return {
        ...state,
        request_management: payload,
      };
    case GET_ROLES:
      return {
        ...state,
        role_list: payload,
      };
    case GET_PERMISSIONS:
      return {
        ...state,
        permission_list: payload,
      };
    case GET_ROLE_NAME:
      return {
        ...state,
        role_name_list: payload,
      };
    case REQ_PROMOTION_DATA:
      console.log(payload, "payload6455");
      return {
        ...state,
        req_promotion: payload,
      };
    case CLIENT_DATA:
      console.log(payload, "payload6455");
      return {
        ...state,
        client_data: payload,
      };
    case GET_SUBSCRIPTION:
      return {
        ...state,
        subscription_list: payload,
      };
    case FORGOT_PASSWORD:
      return {
        ...state,
        forgot_password: payload,
      };
    case IMPORT_DATA_LIST:
      return {
        ...state,
        import_data: payload,
      };
    case COMPANY_SETTING:
      return {
        ...state,
        company_setting: payload,
      };
    case EMPLOYEE_DOC:
      return {
        ...state,
        employee_documents: payload,
      };
    case OPERATOR_DOC:
      return {
        ...state,
        operator_documents: payload,
      };
    case PARTNER_DOC:
      return {
        ...state,
        partner_documents: payload,
      };
    case PRODUCT_OWNER_DATA:
      return {
        ...state,
        product_owner_data: payload,
      };
    case UNREAD_NOTIFICATION:
      console.log(payload, "oldtownroad");
      return {
        ...state,
        unread_notification: payload,
      };
    // case NOTIFICATION_DATA:
    //   return {
    //     ...state,
    //     notification_data: payload,
    //   };
    case GET_ADS_CLIENT:
      return {
        ...state,
        ads_client_list: payload,
      };
    case GET_PERMISSION_COUNT:
      return {
        ...state,
        permission_count: payload,
      };
    case GET_ROLES_COUNT:
      return {
        ...state,
        roles_count: payload,
      };
    case GET_OPERATOR_NAME:
      return {
        ...state,
        operator_name: payload,
      };

    case USER_SETTINGS_EDIT: {
      return {
        ...state,
        user_settings_edit: payload,
      };
    }
    case GET_OP_EMP_COUNT:
      return {
        ...state,
        op_emp_count: payload,
      };
    case GET_PRO_EMP_COUNT:
      return {
        ...state,
        pro_emp_count: payload,
      };
    case GET_MOBILE_ADS:
      return {
        ...state,
        mobile_adsList: payload,
      };
    case GET_OPERATOR_NAME:
      return {
        ...state,
        operator_name: payload,
      };

    case GET_OPERATOR_EMAILID: {
      // console.log(payload, "payloadpayload");
      return {
        ...state,
        get_all_operator_email: payload,
      };
    }

    case GET_ALL_EMAIL_INFO: {
      return {
        ...state,
        get_all_email_info: payload,
      };
    }
    case GET_RECENT_PROMOFILE: {
      return {
        ...state,
        get_recent_promofile: payload,
      };
    }

    case GET_RECENT_ADS: {
      return {
        ...state,
        get_recent_ads: payload,
      };
    }

    case GET_RECENT_OFFERS: {
      return {
        ...state,
        get_recent_offers: payload,
      };
    }

    case NOTIFICATION_DATA:
      console.log(payload, "reducer notifiaction");
      console.log(payload_count, "payload_count");
      return {
        ...state,
        notification_data: payload,
        notification_count: payload_count,
      };
    case REQ_MAN_OFFERS:
      return {
        ...state,
        req_man_offers: payload,
      };
    case GET_REQ_ADS: {
      return {
        ...state,
        get_req_ads: payload,
      };
    }
    case OPERATOR_BYID:
      console.log(payload, "operator_byid");
      return {
        ...state,
        operator_byid: payload,
      };
    case PARTNER_BYID:
      console.log(payload, "partner_byid");
      return {
        ...state,
        partner_byid: payload,
      };
    case BIN_DATA:
      return {
        ...state,
        bin_data: payload,
      };

    case TBS_INFO:
      console.log(payload, "tbs_info");
      return {
        ...state,
        tbs_info: payload,
      };
    case REFER_EARN:
      console.log(payload, "refer_earn");
      return {
        ...state,
        refer_earn: payload,
      };
    case REDEEM_OFFER:
      console.log(payload, "REDEEM_OFFER");
      return {
        ...state,
        redeem_offer: payload,
      };
    case OPERATOR_DATA:
      console.log(payload, "OPERATOR_DATA");
      return {
        ...state,
        operator_data: payload,
      };
    case PROMO_BG_IMAGE:
      console.log(payload, "payload988585858");

      return {
        ...state,
        promo_bg: payload,
      };
    case GET_REQ_PARTNER:
      return {
        ...state,
        get_req_partner: payload,
      };
    case GET_ROLES_PERMISSION:
      console.log(payload, "GET_ROLES_PERMISSION");
      return {
        ...state,
        get_roles_permission: payload,
      };

    case GET_REQ_MOB_ADS: {
      return {
        ...state,
        get_req_mob_ads: payload,
      };
    }
    case THEME_BACKGROUND: {
      return {
        ...state,
        theme_background: payload,
      };
    }

    // case STARTER_IMAGE: {
    //   return {
    //     ...state,
    //     starter_image: payload,
    //   }
    // }

    // case GET_BG_IMAGE: {
    //   return{
    //     ...state,
    //     get_bg_image: payload,
    //   }
    // }
    case GET_BOOKING_DETAILS:
      console.log(payload, "BOOKING_DETAILS");
      return {
        ...state,
        booking_details: payload,
      };
    case GET_DASHBOARD_DETAILS:
      console.log(payload, "DASHBOARD_DETAILS");
      return {
        ...state,
        dashboard_details: payload,
      };
    case GET_CANCELLATION_DETAILS:
      console.log(payload, "GET_CANCELLATION_DETAILS");
      return {
        ...state,
        cancellation_details: payload,
      };
    case GET_PASSENGER_DETAILS:
      console.log(payload, "GET_PASSENGER_DETAILS");
      return {
        ...state,
        passenger_details: payload,
      };
    case GET_BLOCKED_DETAILS:
      console.log(payload, "GET_BLOCKED_DETAILS");
      return {
        ...state,
        blocked_details: payload,
      };
    case GET_ALL_MOBILE_NUMBERS:
      console.log(payload, "GET_ALL_MOBILE_NUMBERS");
      return {
        ...state,
        all_mobile_numbers: payload,
      };
    case GET_AVAILABLE_BALANCE:
      console.log(payload, "GET_AVAILABLE_BALANCE");
      return {
        ...state,
        available_balance: payload,
      };
    case GET_PAYMENT_DETAILS:
      console.log(payload, "GET_PAYMENT_DETAILS");
      return {
        ...state,
        payment_details: payload,
      };
    case GET_SETTLEMENT_DETAILS:
      console.log(payload, "GET_SETTLEMENT_DETAILS");
      return {
        ...state,
        settlement_details: payload,
      };
    case GET_REFUND_DETAILS:
      console.log(payload, "GET_REFUND_DETAILS");
      return {
        ...state,
        refund_details: payload,
      };
    case GET_USAGE_DETAIL:
      console.log(payload, "GET_USAGE_DETAIL");
      return {
        ...state,
        usage_details: payload,
      };
    case GET_BARCHART_DETAILS:
      console.log(payload, "GET_REFUND_DETAILS");
      return {
        ...state,
        barchart_details: payload,
      };
    case GET_MOBILE_NOTIFICATION:
      console.log(payload, "GET_MOBILE_NOTIFICATION");
      return {
        ...state,
        mobile_notification: payload,
      };
    case GET_ACCESSID:
      console.log(payload, "GET_ACCESSID");
      return {
        ...state,
        access_id: payload,
      };
    case GET_TBS_DEAL:
      console.log(payload, "GET_TBS_DEAL");
      return {
        ...state,
        tbs_deal: payload,
      };
    case GET_ABHIBUS_HISTORY:
      console.log(payload, "GET_ABHIBUS_HISTORY");
      return {
        ...state,
        abhibus_history: payload,
      };
    case GET_PAT_DASHBOARD_DETAILS:
      console.log(payload, "GET_PAY_DASHBOARD_DETAILS");
      return {
        ...state,
        pat_dashboard_details: payload,
      };
    case GET_PAT_INSTALL_DETAILS:
      console.log(payload, "GET_PAY_DASHBOARD_DETAILS");
      return {
        ...state,
        pat_install_details: payload,
      };
    case GET_PAT_BOOKING_DETAILS:
      console.log(payload, "GET_PAY_DASHBOARD_DETAILS");
      return {
        ...state,
        pat_booking_details: payload,
      };
    case GET_SETTLEMENT_DETAILS_BY_MONTH:
      console.log(payload, "GET_SETTLEMENT_DETAILS_BY_MONTH");
      return {
        ...state,
        settlement_bymonth: payload,
      };
    case GET_REFUND_REQUEST:
      console.log(payload, "GET_REFUND_REQUEST");
      return {
        ...state,
        refund_request: payload,
      };
    case GET_USER:
      console.log(payload, "GET_USER");
      return {
        ...state,
        user_detail: payload,
      };
    case GET_NUMBER:
      console.log(payload, "GET_NUMBER");
      return {
        ...state,
        user_number: payload,
      };
    case RESETNUMBER:
      return {
        ...state,
        user_number: "", // or null, or 0 depending on your data type
      };
    case GET_COMMISSION:
      return {
        ...state,
        commission: payload,
      };
    case GET_RAZORPAY_DETAILS:
      console.log(payload, "DASHBOARD_DETAILS");
      return {
        ...state,
        razorpay_details: payload,
      };
    case GET_APP_VERSIONINFO:
      return {
        ...state,
        app_versioninfo: payload,
      };
    //Super Admin Vault
    case CREDENTIALS_LIST:
      return {
        ...state,
        credentials_list: payload,
        credentials_page_context: pageContext,
      };

    case DOCUMENTS_LIST:
      return {
        ...state,
        documents_list: payload,
        documents_page_context: pageContext,
      };

    case CONTACTS_LIST:
      return {
        ...state,
        contacts_list: payload,
        contacts_page_context: pageContext,
      };
  case DOCUMENTS_LIST:
  return {
    ...state,
    documents_list:payload,
    pageContext: pageContext,
  };
    case ADMIN_ACTIVITY_LOG:
        return{
          ...state,
          admin_activity_log:payload,
          admin_logs_page_context: pageContext
   };
    default:
      return state;
  }
};

// const initialBgImageState = {
//   bggImage: null,
// };

// export const bgImageReducer = (state = initialBgImageState, action) => {
//   switch (action.type) {
//     case 'GET_BG_IMAGE':
//       return { ...state, bggImage: action.payload };
//     default:
//       return state;
//   }
// };
